/**
 * @module 广告相关模块路由
 */
import { ADV_ASSET_PAGE_ROUTE } from '@/config/adv-asset-info'

export default [
  // H5 贷超仅用于CA回跳等待，页面不展示标题或状态文案。
  {
    path: '/auth-adv/h5-ca-loading',
    name: 'auth_adv_h5_ca_loading',
    component: () => import('@/pages/auth-adv/h5-ca-loading.vue'),
    meta: { title: '' }
  },
  // 首页
  {
    path: '/home/adv',
    name: 'home_adv',
    component: () => import('@/pages/home/adv.vue'),
    meta: {
      title: '智选借款'
    }
  },
  // 授信借款
  {
    path: '/borrow-adv/credit',
    name: 'borrow_adv_credit',
    component: () => import('@/pages/borrow-adv/credit/index.vue'),
    meta: {
      title: '智选借款'
    }
  },
  // 授信授信loading
  {
    path: '/auth-adv/loading',
    name: 'auth_adv_loading',
    component: () => import('@/pages/auth-adv/loading.vue'),
    meta: {
      title: '请稍后...'
    }
  },
  // 基本信息
  {
    path: '/auth-adv/basicInfo',
    name: 'auth_adv_basic-info',
    component: () => import('@/pages/auth-adv/basic-info.vue'),
    meta: {
      title: '基本信息'
    }
  },
  // 资产补录和全量修改共用页面，模式只影响展示，不授予自动申请权限。
  {
    ...ADV_ASSET_PAGE_ROUTE,
    component: () => import('@/pages/auth-adv/asset-info.vue')
  },
  // 数柚联登页
  {
    path: '/borrow-adv/qhsy',
    name: 'borrow_adv_qhsy',
    component: () => import('@/pages/borrow-adv/qh/shuyou.vue'),
    meta: { title: '加载中' }
  },
  // 产品列表
  {
    path: '/borrow-adv/money/semi-products',
    name: 'borrow_adv_semi_products',
    component: () => import('@/pages/borrow-adv/money/semi-products.vue'),
    meta: {
      title: '智选借款'
    }
  },
  // 机构产品协议确认
  {
    path: '/borrow-adv/jg-product',
    name: 'borrow_adv_jg_product',
    component: () => import('@/pages/borrow-adv/money/jg-product.vue'),
    meta: {
      title: '机构产品'
    }
  },
  // 申请提现
  {
    path: '/borrow-adv/money/withdraw',
    name: 'borrow_adv_withdraw',
    component: () => import('@/pages/borrow-adv/money/withdraw.vue'),
    meta: {
      title: '申请提现'
    }
  },
  // 授信借款结果页
  {
    path: '/borrow-adv/result/credit',
    name: 'borrow_adv_result_credit',
    component: () => import('@/pages/borrow-adv/result/credit.vue'),
    meta: {
      title: ''
    }
  },
  // 授信提交完成页会员营销
  {
    path: '/borrow-adv/member/submit-result',
    name: 'borrow_adv_member_submit_result',
    component: () => import('@/pages/borrow-adv/member/submit-result.vue'),
    meta: {
      title: '提交中'
    }
  },
  // 智选会员签约
  {
    path: '/borrow-adv/member/sign',
    name: 'borrow_adv_member_sign',
    component: () => import('@/pages/borrow-adv/member/sign.vue'),
    meta: {
      title: '会员签约'
    }
  },
  // 申请借款
  {
    path: '/borrow-adv/money',
    name: 'borrow_adv_money',
    component: () => import('@/pages/borrow-adv/money/index.vue'),
    meta: {
      title: '申请借款'
    }
  },
  // 授信借款/申请借款/绑卡 协议
  {
    path: '/protocol-adv/list',
    name: 'borrow_adv_protocol_list',
    component: () => import('@/pages/protocol-adv/index.vue'),
    meta: {
      title: '协议列表'
    }
  },
  // 申请借款/收银台 绑卡
  {
    path: '/bindbankcard-adv/index',
    name: 'bindbankcard_adv_index',
    component: () => import('@/components/BindCard/index.vue')
  },
  // 申请借款结果页
  {
    path: '/borrow-adv/result/borrow',
    name: 'borrow_adv_result_borrow',
    component: () => import('@/pages/borrow-adv/result/borrow.vue'),
    meta: {
      title: ''
    }
  },
  // 授信借款/申请借款/绑卡 协议
  // {
  //   path: '/protocol-adv/test',
  //   name: 'borrow_adv_protocol_list11',
  //   component: () => import('@/pages/protocol-adv/dialog.vue'),
  //   meta: {
  //     title: '协议列表测试'
  //   }
  // },
  {
    path: '/repayment-adv/waitbill',
    name: 'repayment_adv_waitbill',
    component: () => import('@/pages/repayment-adv/wait-bill/index.vue'),
    meta: {
      title: '未还账单'
    }
  },
  {
    path: '/repayment-adv/advancesettle',
    name: 'repayment_adv_advancesettle',
    component: () => import('@/pages/repayment-adv/advance-settle/index.vue'),
    meta: {
      title: '提前结清'
    }
  },
  {
    path: '/repayment-adv/advancesettlepart',
    name: 'repayment_adv_advancesettlepart',
    component: () => import('@/pages/repayment-adv/advance-settle/part.vue'),
    meta: {
      title: '提前结清'
    }
  },
  {
    path: '/repayment-adv/pay',
    name: 'repayment_adv_pay',
    component: () => import('@/pages/repayment-adv/pay/index.vue'),
    meta: {
      title: '收银台'
    }
  },
  {
    path: '/repayment-adv/loading',
    name: 'repayment_adv_loading',
    component: () => import('@/pages/repayment-adv/result/loading.vue'),
    meta: {
      title: '还款中'
    }
  },
  {
    path: '/repayment-adv/result',
    name: 'repayment_adv_result',
    component: () => import('@/pages/repayment-adv/result/index.vue'),
    meta: {
      title: '还款结果'
    }
  },
  {
    path: '/repayment-adv/thirdwait',
    name: 'repayment_adv_thirdwait',
    component: () => import('@/pages/repayment-adv/result/third-wait.vue'),
    meta: {
      title: '还款中' // 小赢卡贷 - 还款中
    }
  },
  {
    path: '/repayment-adv/loandetail',
    name: 'repayment_adv_loandetail',
    component: () => import('@/pages/repayment-adv/detail-loan/index.vue'),
    meta: {
      title: '借款详情'
    }
  },
  {
    path: '/repayment-adv/settleprove',
    name: 'repayment_adv_settleprove',
    component: () => import('@/pages/repayment-adv/settle-prove/index.vue'),
    meta: {
      title: '结清证明'
    }
  },
  {
    path: '/repayment_adv/settleproveresult',
    name: 'repayment_adv_settleproveresult',
    component: () => import('@/pages/repayment-adv/settle-prove/result.vue'),
    meta: {
      title: '申请已提交'
    }
  },
  {
    path: '/repayment-adv/repaydetail',
    name: 'repayment_adv_repaydetail',
    component: () => import('@/pages/repayment-adv/detail-repay/index.vue'),
    meta: {
      title: '还款详情'
    }
  }
]
